
<div id="app">
    <transition name="fade" mode="out-in">
        <router-view />
    </transition>
    <portal-target multiple name="default" />
    <portal-target multiple name="modal" id="modal" />
    <portal-target multiple name="dropdown" id="dropdown" />
    <portal-target multiple name="popover" id="popover" />
    <portal-target multiple name="drawer" id="drawer" />
    <portal-target multiple name="datePicker" id="datePicker" />
    <portal-target multiple name="sidePanel" id="sidePanel" />
    <portal-target multiple name="cookieConsent" id="cookie-consent" />
    <portal-target multiple name="animation" id="animation" />
    <portal-target multiple name="overlay" id="overlay" />

    <!-- Maintenance Notification - visible on all pages -->
    <MaintenanceNotification
        :notification="maintenanceNotification"
        :isOverviewPage="isOverviewPage"
        @maintenance-finished="handleMaintenanceFinished"
    />

    <!-- Notification Banner - visible on all pages -->
    <NotificationBanner :banner="activeBanner" />

    <PWAInstallPrompt ref="pwaPrompt" />
    <FeatureAnnouncementManager v-if="isAuthenticated" />
    <MaintenanceHandler />
    <CommandPalette />
    <UpdateOverlay :show="showUpdateOverlay" />
</div>
